import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ReusableModalProps {
    open: boolean;
    onClose: () => void;
    onSubmit?: () => void;
    title: string;
    children: React.ReactNode;
    footer?: React.ReactNode;
    width?: 'sm' | 'md' | 'lg' | 'xl';
}

const ReusableModal: React.FC<ReusableModalProps> = ({
    open,
    onClose,
    onSubmit,
    title,
    children,
    footer,
    width = 'sm'
}) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth={width}>
            <DialogTitle sx={{ fontWeight: 'bold', position: 'relative' }}>
                {title}
                <IconButton
                    onClick={onClose}
                    sx={{ position: 'absolute', right: 8, top: 8 }}
                    size="small"
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                {children}
            </DialogContent>

            {footer && (
                <DialogActions sx={{ padding: 2 }}>
                    {footer}
                </DialogActions>
            )}
        </Dialog>
    );
};

export default ReusableModal;
